import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await register(form.name, form.email, form.password);
      toast.success(`Welcome to the house, ${user.name.split(" ")[0]}.`);
      navigate("/account");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not register");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#FFF4E0] min-h-[80vh] grid grid-cols-1 lg:grid-cols-2" data-testid="register-page">
      <div className="flex items-center justify-center px-6 py-20 order-2 lg:order-1">
        <div className="w-full max-w-md">
          <div className="overline mb-3">Members</div>
          <h1 className="font-serif-display text-5xl text-[#1A0F11]">Create an account</h1>
          <p className="text-sm text-[#5C4A4D] mt-3">Join the inner circle for first access and exclusive offers.</p>
          <form onSubmit={submit} className="mt-10 space-y-6">
            <div>
              <div className="label-luxe">Full name</div>
              <input required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} className="input-luxe" data-testid="register-name" />
            </div>
            <div>
              <div className="label-luxe">Email</div>
              <input required type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} className="input-luxe" data-testid="register-email" />
            </div>
            <div>
              <div className="label-luxe">Password</div>
              <input required type="password" minLength={6} value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} className="input-luxe" data-testid="register-password" />
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="register-submit">
              {loading ? "Creating..." : "Create Account"}
            </button>
          </form>
          <p className="text-sm text-[#5C4A4D] mt-8 text-center">
            Already a member? <Link to="/login" className="text-[#831132] hover:underline" data-testid="register-login-link">Sign in</Link>
          </p>
        </div>
      </div>
      <div className="hidden lg:block relative order-1 lg:order-2">
        <img src="https://images.unsplash.com/photo-1632765854612-9b02b6ec2b15?w=1200" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#831132]/40 to-transparent" />
      </div>
    </div>
  );
}
